
import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-popover-cell-renderer',
    template: `
    <span style="cursor: pointer;"><i class="fa fa-info-circle" [ngbPopover]="popoverText" placement="right" popoverClass="info-popover" container="body"></i></span>
   
  `,
    styles: [`
    .info-popover {
      position: relative;
    }
    .info-popover .popover {
      max-width: 520px;
      background-color: #041e42;
      border-radius: 6px;
    }
    .info-popover .popover-header {
      background-color: #041e42;
      border-bottom: none;
      padding: 0;
      display: none;
    }
    .info-popover .popover-body {
      background-color: #041e42;
      color: #ffffff;
      padding: 1rem;
      font-size: 0.95rem;
      line-height: 1.6;
      white-space: pre-line;
      word-break: normal;
      text-align: left;
    }
    .info-popover.bs-popover-right > .popover-arrow::before,
    .info-popover.bs-popover-end > .popover-arrow::before {
      border-right-color: #041e42;
    }
  `],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class PopoverCellRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public popoverText: string = '';
  public showPopover = false;

  agInit(params: any): void {
    this.params = params;
    this.popoverText = this.formatPopoverText(params?.value);
  }

  refresh(): boolean {
    return false;
  }

  togglePopover(): void {
    this.showPopover = !this.showPopover;
  }

  private formatPopoverText(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    const parts = value
      .toString()
      .split(',')
      .map((part: string) => part.trim())
      .filter((part: string) => part.length > 0);

    if (parts.length <= 3) {
      return parts.join(', ');
    }

    const lineCount = parts.length <= 6 ? 2 : 3;
    const itemsPerLine = Math.ceil(parts.length / lineCount);
    const lines: string[] = [];

    for (let i = 0; i < parts.length; i += itemsPerLine) {
      lines.push(parts.slice(i, i + itemsPerLine).join(', '));
    }

    return lines.join('\n');
  }
}